export const BORG_API_ROOT = "/api/ai/api/v1";

export const borgApiPath = (path: string): string => `${BORG_API_ROOT}${path}`;
